import dayjs from '@/utils/dayjsConfig';

/** Java ZonedDateTime may carry a "[Asia/Singapore]" suffix that browsers cannot parse. */
export const parseIso = (iso?: string | null) =>
  dayjs((iso || '').replace(/\[.*\]$/, ''));
